import HouseHasBuildingReport from './HouseHasBuildingReport';
import type { PrivateHouseMissingInformationDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/missingInformation';
import type {
    PrhHolidayHomeDTO,
    PrhHouseDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/prh';
import { FieldBox } from '../FieldBox';
import { Box } from '@flos/react-ui';

const HouseMissingInformationForm = ({
    houseMissingDTO,
    currentCoverable
}: {
    houseMissingDTO: PrivateHouseMissingInformationDTO;
    currentCoverable: PrhHouseDTO | PrhHolidayHomeDTO;
}): React.JSX.Element => {
    return (
        <Box>
            <div>
                <h6>{currentCoverable.flavourName}</h6>
            </div>
            <div key={houseMissingDTO.fixedId}>
                {currentCoverable.buyingHouse === false &&
                    currentCoverable.outputBuildingReportPending !== false && (
                        <div className="u-spacing-inset-m--stretch-max">
                            <FieldBox label={currentCoverable.name}>
                                <HouseHasBuildingReport
                                    key={`${houseMissingDTO.fixedId ?? ''}missingReport`}
                                    houseMissingDTO={houseMissingDTO}
                                />
                            </FieldBox>
                        </div>
                    )}
            </div>
        </Box>
    );
};

export default HouseMissingInformationForm;
